/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
export const DownloadColumnFormatter = ( cellContent, row, rowIndex ) => (
  <>
    <a
      href={`${toAbsoluteUrl("/media/")}${row.banner_file}`}
      title={row.banner_file}
      className="btn btn-light-info btn-sm"
    >
      <i className="fas fa-cloud-download-alt"></i> Download
    </a>
  </>
);
